import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const LogOutPage = () => {
  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
    window.dispatchEvent(new Event('authChange'));
  }, []);

  return <Navigate to="/login" replace />;
};

export default LogOutPage;
